function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61.309 61.309",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M45.443,9.969c2.744,0.315,5.224-1.657,5.539-4.4c0.312-2.743-1.659-5.22-4.403-5.536 c-2.742-0.313-5.223,1.657-5.535,4.4C40.729,7.179,42.699,9.657,45.443,9.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M54.288,23.168c-4.592-1.345-7.341-4.556-9.248-8.68c-0.812-4.061-7.014-6.391-9.701-1.792 c-2.25,3.845-4.375,7.762-6.409,11.722c-0.187,0.363-0.327,0.723-0.429,1.079c-1.145,1.955-7.956,13.536-13.914,22.427 c-2.445,3.144,2.439,6.901,4.877,3.768c3.999-5.145,8.005-13.629,12.007-19.764c0.241,0.594,0.674,1.136,1.364,1.527 c2.924,1.662,5.485,3.891,7.658,6.451c-0.867,3.43-1.734,6.855-2.601,10.286c-0.976,3.856,5.095,4.948,6.062,1.114 c0.909-3.599,1.816-7.196,2.728-10.795c0.08-0.312,0.097-0.603,0.091-0.879c0.221-0.75,0.111-1.604-0.551-2.436 c-2.362-2.973-5.061-5.549-8.149-7.679c1.405-2.728,2.871-5.423,4.371-8.098c2.478,3.432,5.745,6.04,10.296,7.371 C56.357,29.851,57.891,24.221,54.288,23.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M48.449,40.043c-0.011,0.367-0.062,0.737-0.151,1.104l-1.33,5.252v14.907h7.582V37.369h-6.396 C48.542,38.224,48.649,39.14,48.449,40.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M36.842,53.829c-0.83-1.065-1.09-2.438-0.73-3.86l2.374-9.399 c-1.067-1.187-2.198-2.254-3.384-3.199h-1.723v23.938h7.584v-5.668c-0.066,0-0.135,0.009-0.201,0.009 C39.194,55.647,37.729,54.967,36.842,53.829z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M18.555,54.578v6.729h7.582V44.594c-1.766,3.08-3.57,6.054-5.376,8.375 C20.16,53.742,19.401,54.287,18.555,54.578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M4.967,61.306h7.583v-9.377c-0.617-1.271-0.599-2.68,0-3.938V37.369H4.967V61.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M28.932,18.724l6.123-11.109c0,0-7.086-6.828-11.464,0.048c-1.388,2.458-2.599,5.181-3.986,7.639 C17.754,18.577,27.086,21.99,28.932,18.724z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreet);
export default __webpack_public_path__ + "static/media/street.af19dc2d631d73890454dea23f3a1aa5.svg";
export { ForwardRef as ReactComponent };